import { CommonModule, DatePipe, NgForOf } from "@angular/common";
import { Component, inject } from "@angular/core";
import {
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import {
  TuiAlertService,
  TuiDataList,
  TuiDialogService,
  TuiDropdown,
  TuiSizeL,
  TuiSizeS,
  TuiTextfield,
} from "@taiga-ui/core";
import {
  TuiBadgedContent,
  TuiDataListWrapper,
  TuiItemsWithMore,
  TuiTabs,
} from "@taiga-ui/kit";
import {
  TuiNavigation,
  TuiSearch,
} from "@taiga-ui/layout";
import { TuiTable } from "@taiga-ui/addon-table";
import { TuiInputModule, TuiTextfieldControllerModule } from "@taiga-ui/legacy";
import { Location } from "@angular/common";
import { ForgotResetPasswordService } from "../../../core/services/forgot-reset-password.service.service";
import { ClientService } from "../../../core/services/client.service";
import { ChargesService } from "../../../core/services/charges.service";
import { ShiftService } from "../../../core/services/shift.service";
import { formatClientIdentifier } from "../../../shared/utils/client-identifier";

@Component({
  selector: 'app-single-charges',
  imports: [
    FormsModule,
    NgForOf,
    TuiDataListWrapper,
    TuiDataList,
    TuiDropdown,
    TuiTable,
    TuiNavigation,
    TuiTabs,
    TuiTextfield,
    TuiItemsWithMore,
    TuiSearch,
    ReactiveFormsModule,
    CommonModule,
    TuiBadgedContent,
    TuiInputModule,
    TuiTextfieldControllerModule
  ],
  templateUrl: './single-charges.component.html',
  styleUrl: './single-charges.component.scss',
  providers: [DatePipe],
})
export class SingleChargesComponent {
  clientId: string = "";
  month: number = 0;
  year: number = 0;
  client: any | null = null;
  isLoading: boolean = false;
  ChargesRecords: any[] = [];
  private readonly dialogs = inject(TuiDialogService);
  protected size: TuiSizeL | TuiSizeS = "s";
  protected open = false;

  constructor(
    private clientService: ClientService,
    private router: Router,
    private route: ActivatedRoute,
    private resetPasswordService: ForgotResetPasswordService,
    private chargesService: ChargesService,
    private location: Location,
    private shiftService: ShiftService,
    private datePipe: DatePipe,
  ) {
  }

  getClientIdentifier(client: any): string {
    return formatClientIdentifier(client);
  }

  /**
   * Type-aware "Registered on" label so Inward / Unregistered patients aren't
   * mislabeled as Registered.
   */
  getOnboardingLabel(client: any): string {
    if (!client) return "";
    const fmt = (d: any) =>
      d ? this.datePipe.transform(d, "MMM d, y") || "" : "";
    if (client.clientType === "Inward") {
      return client.inwardDate
        ? `Admitted on ${fmt(client.inwardDate)}`
        : "Inward client";
    }
    if (client.clientType === "Unregistered") {
      return client.startingDate
        ? `Started on ${fmt(client.startingDate)}`
        : "Non Registered client";
    }
    return client.registrationDate || client.createdAt
      ? `Registered on ${fmt(client.registrationDate || client.createdAt)}`
      : "";
  }

  ngOnInit() {
    this.clientId = this.route.snapshot.paramMap.get("clientId")!;
    this.month = parseInt(this.route.snapshot.paramMap.get("month")!, 10);
    this.year = parseInt(this.route.snapshot.paramMap.get("year")!, 10);
    if (this.clientId) {
      this.loadClientData();
    }
    if (this.month && this.year) {
      this.loadChargesRecords();
    }
  }


  loadChargesRecords(): void {
    this.isLoading = true;
    this.shiftService.getClientShiftsBySpecificMonth(this.clientId, this.year, this.month).subscribe((res: any) => {
      if (res.success) {
        this.ChargesRecords = res.data.shifts;
      }
      this.isLoading = false;
    });
  }
  

  loadClientData(): void {
    this.isLoading = true;
    if (this.clientId) {
      this.clientService.getOneClientById(this.clientId).subscribe((res: any) => {
        console.log(res);
        this.client = res;
        this.isLoading = false;
      });
    }
  }

  getTotalShifts(): number {
    return this.ChargesRecords.reduce((acc, record) => acc + record.shifts.length, 0);
  }
  
  getNetCharge(): number {
    return this.ChargesRecords.reduce((acc, record) => acc + record.charges, 0);
  }
  
  getMonthName(month: number): string {
    const date = new Date(2000, month - 1);
    return date.toLocaleString('default', { month: 'long' });
  }
  

  private readonly alerts = inject(TuiAlertService);

  protected activeItemIndex = 0;

  protected onClick(item: string): void {
    this.alerts.open(item).subscribe();
  }

  goBack(): void {
    this.location.back();
  }

}
